import { useCallback, type MouseEvent } from 'react';
import { useIsApp } from '@/core/hooks/useIsApp';
import { openWebViewLink } from '@/core/utils/openWebViewLink';

export function useOpenWebViewLink() {
  const isApp = useIsApp();

  const openLink = useCallback(
    (link: string, event?: { preventDefault(): void }) => {
      openWebViewLink(link, { event, isApp });
    },
    [isApp]
  );

  const createClickHandler = useCallback(
    (link: string) => (event: MouseEvent<HTMLAnchorElement>) => {
      openLink(link, event);
    },
    [openLink]
  );

  return { openLink, createClickHandler, isApp };
}
